import React, { Component } from 'react';
import { Card, Typography, Button, Space, Divider, Tag, Carousel, message } from 'antd';
import { LeftOutlined, ShoppingCartOutlined, FileTextOutlined } from '@ant-design/icons';
import ItemImage from './ItemImage';
import MobileCartSelect from "../CartSelect/MobileCartSelect";
// import { toast } from 'react-toastify';
import treeViewData from './treeView.json';

const { Text, Title } = Typography;
const treeDataSource = treeViewData;

class MobileItemDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cartselect: false,
        };
    }

    addCart = () => {
        this.setState({ cartselect: true });
    };

    closeCart = (added) => {
        this.setState({ cartselect: false });
        if (added) {
            message.success("カートに追加しました");
        }
    };

    render() {
        const { data, userOrg, org, storage, db, user, dateNow } = this.props;

        if (!data) return null;

        let isBuyer = false;
        let isSeller = false;
        if ((userOrg && userOrg.buyer && org && org.reseller) || (userOrg && userOrg.reseller && org && org.maker)) {
            isBuyer = true;
        }
        if ((userOrg && userOrg.reseller && org && org.buyer) || (userOrg && userOrg.maker && org && org.reseller)) {
            isSeller = true;
        }

        let priceText = '';
        if (!data['price'] || (data['price'] && data['price'][0] && !data['price'][0]['price'])) {
            priceText = '要見積';
        }
        if (data['price'] && data['price'][0] && !data['price'][0]['expiration_date']) {
            priceText = '要見積';
        }
        if (data['archive']) {
            priceText = '現在お取り扱いしていません';
        }
        if (data['price'] && data['price'][0] && data['price'][0]['expiration_date']) {
            let expiration_date = data['price'][0]['expiration_date'];
            let expDate = expiration_date.toDate();
            if ((expDate.getTime() - dateNow) < 0) {
                priceText = '価格有効期限切れ要見積';
            }
        }

        const disableButton = !!priceText;

        // Collect Images
        let images = [];
        if (data.image) {
            images.push({ type: 'direct', src: data.image });
        }
        if (data.image2) images.push({ type: 'direct', src: data.image2 });
        if (data.image3) images.push({ type: 'direct', src: data.image3 });
        
        if (images.length === 0 && data['files'] && data['files'][0]) {
            images.push({ type: 'files', src: data['files'][0]['file'] });
        }

        // Category Path
        let categoryPath = '';
        if (data['大分類'] && data['中分類'] && data['小分類']) {
            let majorName = treeDataSource.find(e => e.level === 'major' && e.code === `${data['大分類']}`)?.name || '';
            let middleName = treeDataSource.find(e => e.level === 'middle' && e.code === `${data['中分類']}`)?.name || '';
            let smallName = treeDataSource.find(e => e.level === 'small' && e.code === `${data['小分類']}`)?.name || '';
            categoryPath = `${data['大分類']} ${majorName} / ${data['中分類']} ${middleName} / ${data['小分類']} ${smallName}`;
        }

        // Files
        let files = [];
        if (data['files']) {
            for (let i in data['files']) {
                files.push(data['files'][i]);
            }
        }

        return (
            <div style={{ background: '#f5f5f5', minHeight: '100vh', paddingBottom: '80px' }}>
                {/* Header */}
                <div style={{ background: '#fff', padding: '12px 16px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)', marginBottom: '8px' }}>
                    <Button 
                        type="link" 
                        icon={<LeftOutlined />} 
                        onClick={() => window.history.back()}
                        style={{ padding: 0, color: '#1890ff', display: 'flex', alignItems: 'center' }}
                    >

                        <span style={{ marginLeft: '4px' }}>戻る</span>
                    </Button>
                </div>
                <Card bordered={false} bodyStyle={{ padding: 0 }}>
                    {/* Image Carousel */}
                    {images.length > 0 ? (
                        <Carousel autoplay>
                            {images.map((img, idx) => (
                                <div key={idx} style={{ height: '300px', width: '100%', background: '#fff' }}>
                                    <div style={{ height: '300px', padding: '15px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <ItemImage 
                                            src={img.src} 
                                            storage={storage} 
                                            style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }} 
                                        />
                                    </div>
                                </div>
                            ))}
                        </Carousel>
                    ) : (
                        <div style={{ height: '200px', width: '100%', background: '#fafafa', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#bfbfbf', borderBottom: '1px solid #f0f0f0' }}>
                            <ShoppingCartOutlined style={{ fontSize: '48px' }} />
                        </div>
                    )}

                    <div style={{ padding: '20px' }}>
                        {isSeller && data['archive'] && (
                            <Tag color="default" style={{ marginBottom: '10px' }}>アーカイブ済</Tag>
                        )}

                        <Title level={4} style={{ marginBottom: '4px', fontSize: '1.2rem', lineHeight: '1.4' }}>
                            {data['P4CLOUD商品名']}
                        </Title>
                        
                        <Space direction="vertical" size={16} style={{ width: '100%', marginTop: '16px' }}>

                            {/* Price Section */}
                            <div style={{ padding: '16px', background: '#fafafa', borderRadius: '8px', border: '1px solid #f0f0f0' }}>
                                <Text type="secondary" style={{ display: 'block', fontSize: '0.85rem', marginBottom: '4px' }}>価格</Text>
                                {priceText ? (
                                    <Text strong style={{ color: '#d32f2f', fontSize: '1.4rem' }}>{priceText}</Text>
                                ) : (
                                    <Text strong style={{ fontSize: '1.4rem' }}>{Number(data['price'][0]['price']).toLocaleString()}円</Text>
                                )}
                                {data['消費税率'] && (
                                    <Text type="secondary" style={{ display: 'block', marginTop: '4px', fontSize: '0.8rem' }}>
                                        消費税率: {data['消費税率'] * 100}%
                                    </Text>
                                )}
                            </div>

                            {/* Info Section */}
                            <div>
                                {data['No'] && (
                                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #f0f0f0' }}>
                                        <Text type="secondary">No</Text>
                                        <Text>{data['No']}</Text>
                                    </div>
                                )}
                                {data['正式メーカー名'] && (
                                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #f0f0f0' }}>
                                        <Text type="secondary">メーカー名</Text>
                                        <Text>{data['正式メーカー名']}</Text>
                                    </div>
                                )}
                                {data['メーカー商品コード'] && (
                                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #f0f0f0' }}>
                                        <Text type="secondary">メーカー商品コード</Text>
                                        <Text>{data['メーカー商品コード']}</Text>
                                    </div>
                                )}
                                {data['容量・入数'] && (
                                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #f0f0f0' }}>
                                        <Text type="secondary">容量・入数</Text>
                                        <Text>{data['容量・入数']}</Text>
                                    </div>
                                )}
                                {data['発注単位'] && (
                                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #f0f0f0' }}>
                                        <Text type="secondary">発注単位</Text>
                                        <Text>{data['発注単位']}</Text>
                                    </div>
                                )}
                                {data['単位'] && (
                                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #f0f0f0' }}>
                                        <Text type="secondary">単位</Text>
                                        <Text>{data['単位']}</Text>
                                    </div>
                                )}
                            </div>

                            {/* Additional Seller/Buyer Info */}
                            {((userOrg && userOrg.maker) || (org && org.buyer && userOrg && userOrg.reseller)) && (
                                <div style={{ background: '#fafafa', padding: '12px', borderRadius: '6px' }}>
                                    {data['仕入先（本社）'] && (
                                        <div style={{ marginBottom: '8px' }}>
                                            <Text type="secondary" style={{ display: 'block', fontSize: '0.8rem' }}>仕入先名</Text>
                                            <Text>{data['仕入先（本社）']}</Text>
                                        </div>
                                    )}
                                    {data['仕入先事業所名'] && (
                                        <div>
                                            <Text type="secondary" style={{ display: 'block', fontSize: '0.8rem' }}>仕入先事業所名</Text>
                                            <Text>{data['仕入先事業所名']}</Text>
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Category & Files */}
                            {categoryPath && (
                                <div style={{ paddingTop: '8px' }}>
                                    <Text type="secondary" style={{ display: 'block', fontSize: '0.8rem', marginBottom: '4px' }}>カテゴリ</Text>
                                    <Text style={{ fontSize: '0.9rem' }}>{categoryPath}</Text>
                                </div>
                            )}

                            {files.length > 0 && (
                                <div style={{ paddingTop: '16px' }}>
                                    <Text strong style={{ display: 'block', marginBottom: '8px' }}>関連ファイル</Text>
                                    <Space size={[8, 8]} wrap>
                                        {files.map((f, i) => (
                                            <Button 
                                                key={i} 
                                                icon={<FileTextOutlined />} 
                                                size="small"
                                                onClick={() => {
                                                    storage.refFromURL(f.file).getDownloadURL().then((url) => {
                                                        window.open(url, '_blank');
                                                    });
                                                }}
                                            >
                                                {f.name}
                                            </Button>
                                        ))}
                                    </Space>
                                </div>
                            )}
                        </Space>
                    </div>
                </Card>

                {/* Sticky Bottom Action Bar */}
                {((userOrg && userOrg.buyer) || (userOrg && userOrg.reseller && org && org.maker)) && (
                    <div style={{
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        padding: '16px',
                        background: '#fff',
                        borderTop: '1px solid #f0f0f0',
                        boxShadow: '0 -2px 10px rgba(0,0,0,0.05)',
                        zIndex: 1000
                    }}>
                        <Button 
                            type="primary" 
                            size="large" 
                            block
                            disabled={disableButton}
                            onClick={this.addCart}
                            style={{ borderRadius: '8px', height: '48px', fontSize: '1.1rem' }}
                        >
                            {priceText ? priceText : 'カート'}
                        </Button>
                    </div>
                )}

                {this.state.cartselect && (
                    <MobileCartSelect
                        isOpen={this.state.cartselect}
                        onClose={this.closeCart}
                        type="standard"
                        data={data}
                        db={db}
                        user={user}
                        org={org}
                        userOrg={userOrg}
                        dateNow={dateNow}
                    />
                )}
            </div>
        );
    }
}

export default MobileItemDetail;
